/**
 * Payout statuses that all mean the disbursement failed and the participant
 * needs to update their payment account (which triggers an automatic PPS
 * retry). The backend reports the specific reason; the participant just sees
 * "failed".
 */
const FAILED_PAYOUT_STATUSES: ReadonlySet<string> = new Set([
  "failed",
  "missing_payment_details",
  "invalid_payment_account",
]);

export const isFailedPayoutStatus = (
  status: string | null | undefined
): boolean => FAILED_PAYOUT_STATUSES.has((status ?? "").toLowerCase());
